<script setup>
import { onMounted, ref } from 'vue'
import { getI18n } from '@/plugins/i18n'

import { usePlanningStore } from '@/stores/planning.store'

import GridDetailTabs from '@/components/shared/GridDetailTabs.vue'
import CompanyContactsGrid from '@/components/planner/CompanyContactsGrid.vue'
import CompanyInfo from '@/components/planner/CompanyInfo.vue'
import CompanyActivity from '@/components/planner/CompanyActivity.vue'
import { featureFlags } from '@/composables/feature-flags'

const props = defineProps({
  company: {
    type: Object,
    required: true,
  },
})

const { t } = getI18n()
const planningStore = usePlanningStore()
const tab = ref('info')
const company = ref(props.company)

onMounted(async() => {
  company.value = { ...props.company, ...(await planningStore.fetchCompanyByIdAsync(props.company.id)).data }
})
</script>

<template>
  <grid-detail-tabs v-model="tab">
    <template #tabs>
      <q-tab name="info" :label="t('common.info')" />
      <q-tab name="contacts" :label="t('common.contact', 2)" />
      <q-tab
        v-if="featureFlags.COMPANY_ACTIVITY_TAB"
        name="activity"
        :label="t('common.activity')"
      />
    </template>
    <template #panels>
      <q-tab-panel name="info" class="q-pa-none">
        <company-info :company="company" />
      </q-tab-panel>
      <q-tab-panel name="contacts" class="q-pa-none">
        <company-contacts-grid :company="props.company" />
      </q-tab-panel>
      <q-tab-panel v-if="featureFlags.COMPANY_ACTIVITY_TAB" name="activity" class="q-pa-none">
        <company-activity :company="props.company" />
      </q-tab-panel>
    </template>
  </grid-detail-tabs>
</template>
